export default "__VITE_ASSET__69dcf0e1__"